<template>
	<section>
		<div class="text-center w-75 m-auto">
			<h4 class="text-dark-50 text-center mt-0 font-weight-bold">Recuperar senha</h4>
		</div>

		<div class="form-group">
			<div class="field">
				<input type="email" id="txtLogin" class="input" v-model="params.email" autofocus placeholder="Informe seu email cadastrado">
				<label for="txtLogin" class="label">Email</label>
			</div>
		</div>

		<div class="form-group mb-0 text-center">
			<button class="btn btn-sm btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2" type="submit" @click="submit">Enviar</button>
		</div> 

		<div class="row mt-3">
			<div class="col-12 text-center">
				<p><router-link to="Login" class="text-dark ml-1"><b>Voltar</b></router-link> para tela de login.</p>
			</div>
		</div>  
	</section>
</template>

<script>
	import api 	  from '@/mixins/api.js'
	import alert  from "@/components/Tools/alert.vue"

	export default {
		name: "Recovery",
		mixins: [api],

		data() { return { params: { email: null } }},

		methods: {
			async submit() {
				if ( this.params.email ) {
					const response = await this.POST("Auth/Recovery", this.params)
					this.$router.push("/Email/Enviado")
				}

				else this.show_alert({ status: "error", result: "Email não informado!"})
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger"
				this.alert.msg  = payload.result

				$("#app-alert").show()
				setTimeout(() => $("#app-alert").hide(), 3000 )
			}
		}
	}
</script>

<style lang="scss">
	@import "../../../assets/sass/login.scss";
</style>